import { render, staticRenderFns } from "./focus.vue?vue&type=template&id=fc56e2ec&scoped=true"
import script from "./focus.vue?vue&type=script&lang=js"
export * from "./focus.vue?vue&type=script&lang=js"
import style0 from "./focus.vue?vue&type=style&index=0&id=fc56e2ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc56e2ec",
  null
  
)

export default component.exports